import type { ChangeEvent } from "react";
import type { Rule } from "antd/es/form";
import { isStrongPassword } from "@/components/auth/PasswordRules";
import {
  formatCpfOrCnpj,
  formatIntlPhone,
  formatPhone,
  validateAccountName,
  validateCpfOrCnpj,
  validateDomain,
  validateEmail,
  validateIntlPhone,
  validateName,
  validatePhone,
} from "@/utils/validation";

// Adapta os validadores existentes (string de erro | null) ao Form do antd.
const from = (validate: (value: string) => string | null): Rule => ({
  validator: (_, value?: string) => {
    const error = validate(value ?? "");
    return error ? Promise.reject(new Error(error)) : Promise.resolve();
  },
});

export const RULES = {
  name: [from((v) => validateName(v.trim()))],
  email: [from((v) => validateEmail(v.trim()))],
  // Telefone é obrigatório em todo formulário que o pede.
  phone: [from((v) => (v.trim() ? validatePhone(v) : "Informe seu telefone"))],
  // Com código do país (formulários que enviam lead à RD Station).
  intlPhone: [from((v) => (v.replace(/\D/g, "") ? validateIntlPhone(v) : "Informe seu telefone"))],
  password: [
    { required: true, message: "Por favor, informe sua senha" },
    from((v) => (v && !isStrongPassword(v) ? "A senha ainda não atende a todos os requisitos abaixo." : null)),
  ] as Rule[],
  accountName: [from((v) => validateAccountName(v.trim()))],
  companyName: [from((v) => (v.trim() ? null : "Informe o nome da sua empresa"))],
  domain: [from(validateDomain)],
  document: [from(validateCpfOrCnpj)],
};

// Máscaras aplicadas enquanto o usuário digita.
export const MASKS = {
  phone: (e: ChangeEvent<HTMLInputElement>) => formatPhone(e.target.value),
  intlPhone: (e: ChangeEvent<HTMLInputElement>) => formatIntlPhone(e.target.value),
  document: (e: ChangeEvent<HTMLInputElement>) => formatCpfOrCnpj(e.target.value),
  // Só o domínio principal: sem protocolo, www, caminho ou parâmetros.
  domain: (e: ChangeEvent<HTMLInputElement>) =>
    e.target.value
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .replace(/\/.*$/, "")
      .replace(/\?.*$/, ""),
};
